// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__xEuYu","legacyBtn":"MutateMid_legacyBtn__3-DAd"};